'use strict';

function initialize($wrapper) {
  $wrapper.find('.loadOtherItems').k2_loadOtherItems();
  $wrapper.find('.material-whisper').k2_whisper();
}

$(document).ready(function () {
  initialize($('body'));
});
